import { Link } from "react-router-dom"
import { toSalusionPrivate } from "../../util"
import Lottie from "lottie-react"

import animationHero from "../../lottie/salutions-hero.json"
import { Helmet } from "react-helmet-async"

export default function Hero() {

	return (
		<section className="first-section first-padding" id="hero">
			<Helmet>

			</Helmet>

			<div className="container">
				<div className="row align-items-center">
					<div className="col-12 col-md-7">
						<div className="hero-content">
							<h1>Health&nbsp;Benefits Designed for Small&nbsp;Business</h1>
							<p>Administer QSEHRAs and ICHRAs in minutes — compliant, automated, and affordable</p>

							{/* <Link className="btn-linear" onClick={(event) => toSalusionPrivate(event, "/create-account", false)}> */}
							<Link to="/create-account" className="btn-linear" onClick={(event) => toSalusionPrivate(event, "/create-account", false)}>
								Start Your Company's HRA Now
							</Link>
						</div>
					</div>
					<div className="col-12 col-md-5">
						<div className="hero-animation">
							<Lottie animationData={animationHero} loop={false} />
						</div>
					</div>
				</div>
			</div>
		</section>
	)
}
